import request from '@/utils/request';
export function getTotalHead() {
    return request({
      url: `/visualization/date/totalHead`,
      method: 'get',
    });
  }
  export function getTodayResouceRecycle() {
    return request({
      url: `/visualization/date/todayResouceRecycle`,
      method: 'get',
    });
  }
  export function getResouceRecycle() {
    return request({
      url: `/visualization/date/resouceRecycle`,
      method: 'get',
    });
  }
  export function getReductionEnergy() {
    return request({
      url: `/visualization/date/reductionEnergy`,
      method: 'get',
    });
  }
  export function getCommunityOrder() {
    return request({
      url: `/visualization/date/communityOrder`,
      method: 'get',
    });
  }
  export function getTodayRecycle() {
    return request({
      url: `/visualization/date/todayRecycle`,
      method: 'get',
    });
  }
  export function getHistoryRecycle() {
    return request({
      url: `/visualization/date/historyRecycle`,
      method: 'get',
    });
  }
  export function getCommunityTotalHead(id) {
    return request({
      url: `/visualization/community/totalHead/${id}`,
      method: 'get',
    });
  }
  export function getCommunityTodayResouceRecycle(id) {
    return request({
      url: `/visualization/community/todayResouceRecycle/${id}`,
      method: 'get',
    });
  }
  export function getCommunityResouceRecycle(id) {
    return request({
      url: `/visualization/community/resouceRecycle/${id}`,
      method: 'get',
    });
  }
  export function getCommunityReductionEnergy(id) {
    return request({
      url: `/visualization/community/reductionEnergy/${id}`,
      method: 'get',
    });
  }
  export function getCommunityCommunityOrder(id) {
    return request({
      url: `/visualization/community/communityOrder/${id}`,
      method: 'get',
    });
  }
  export function getCommunityTodayRecycle(id) {
    return request({
      url: `/visualization/community/todayRecycle/${id}`,
      method: 'get',
    });
  }
  export function getCommunityHistoryRecycle(id) {
    return request({
      url: `/visualization/community/historyRecycle/${id}`,
      method: 'get',
    });
  }
  export function getCommunitys() {
    return request({
      url: `wlCommunityDict/likeSearch`,
      method: 'get',
    });
  }
  export function getCarGpsList() {
    return request({
      url: `/visualization/gps/carGpsList`,
      method: 'get',
    });
  }
  export function getCleanCarGpsList() {
    return request({
      url: `/visualization/gps/cleanCarGpsList`,
      method: 'get',
    });
  }
  export function getGarbagePointList() {
    return request({
      url: `/visualization/gps/garbagePointList?type=1`,
      method: 'get',
    });
  }
  export function getRecyclerGpsList() {
    return request({
      url: `/visualization/gps/queryRecyclerGpsList`,
      method: 'get',
    });
  }
  export function getTimeOutOrderNums(streetId) {
    return request({
      url: `/visualization/gps/timeOutOrderNums?streetId=${streetId}`,
      method: 'get',
    });
  }
  export function getRecycleDeviceList(streetId) {
    return request({
      url: `/visualization/gps/recycleDeviceList?streetId=${streetId}`,
      method: 'get',
    });
  }